import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  moreInfo: {
    id: 'search.venueItem.moreInfo',
    defaultMessage: 'more info',
  },
  lessInfo: {
    id: 'search.venueItem.lessInfo',
    defaultMessage: 'less info',
  },
  seeAllReviews: {
    id: 'search.venueItem.seeAllReviews',
    defaultMessage: 'see all reviews',
  },
});
